import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import messages from './../../../text/messages';
import Modal from './../../../components/modal';
import { getJob } from './../../../reducers/onboarding';
import { RoleDefinitions } from './../../../utilities/roles';
import { getPendingJobRequirement } from './../../../utilities/requirements';
import { logout } from './../../../reducers/identity';

class OnboardingDialog extends React.Component {
    constructor(props) {
        super(props);

        this.isUserEligibleForOnboarding = this.isUserEligibleForOnboarding.bind(this);
        this.renderTitle = this.renderTitle.bind(this);
        this.renderMessage = this.renderMessage.bind(this);
        this.renderButtons = this.renderButtons.bind(this);
    }

    componentDidMount() {
        const { role, job, getJob, requirements } = this.props;
        if (role.role === RoleDefinitions.Contractor.type && !job) {
            let jobRequirement = getPendingJobRequirement(requirements);
            if (jobRequirement && jobRequirement.entity_id) {
                getJob(jobRequirement.entity_id);
            }
        }
    }

    isUserEligibleForOnboarding() {
        const { role, user, details } = this.props;

        if (role.role === RoleDefinitions.Contractor.type || role.role === RoleDefinitions.Admin.type) {
            return true;
        }

        if (role.role === RoleDefinitions.Client.type) {
            if (!details.contact_user) {
                return true;
            }

            if (details.contact_user !== user.id) {
                return false;
            }

            return true;
        }

        return true;
    }

    renderTitle() {
        const { role, client } = this.props;

        let title =
            role.role === RoleDefinitions.Contractor.type ? (
                <FormattedHTMLMessage
                    id={'onboardingDialog.welcomeContractor'}
                    defaultMessage={'Contracting offer from {client}'}
                    values={{ client: client.name }}
                    tagName={'h4'}
                />
            ) : (
                <FormattedMessage id={'onboardingDialog.welcome'} defaultMessage={'Welcome!'} tagName={'h4'} />
            );
        return (
            <div className="row section">
                <div className="col-xs-12 onboarding-dialog-title">{title}</div>
            </div>
        );
    }

    renderMessage() {
        const { role, details } = this.props;
        const eligibleMessage =
            role.type === 'contractor' ? (
                <FormattedMessage
                    id={'onboardingDialog.introContinue'}
                    defaultMessage={'Welcome back.  We saved your progress, so you can continue from where you left off.'}
                    tagName={'p'}
                />
            ) : (
                <FormattedMessage id={'onboardingDialog.introFresh'} defaultMessage={"Let's get started with your onboarding"} tagName={'p'} />
            );
        const notEligibleMessage = (
            <FormattedMessage
                id={'onboardingDialog.introFreshNotEligible'}
                defaultMessage={'You need to wait for {company} to complete onboarding process.'}
                values={{ company: details.name }}
                tagName={'p'}
            />
        );
        return (
            <div className="row section">
                <div className="col-xs-12">{this.isUserEligibleForOnboarding() ? eligibleMessage : notEligibleMessage}</div>
            </div>
        );
    }

    renderButtons() {
        const { role, closeDialog, logout } = this.props;

        if (this.isUserEligibleForOnboarding()) {
            return (
                <div className="row">
                    <div className="col-xs-12">
                        <button id="onboarding-dialog-button" type="button" className="onboarding-dialog-button" onClick={closeDialog}>
                            <FormattedMessage {...(role.type === 'contractor' ? messages.continueOnboarding : messages.startOnboarding)} />
                        </button>
                    </div>
                </div>
            );
        }

        return (
            <div className="row">
                <div className="col-xs-12">
                    <button type="button" className="onboarding-dialog-button" onClick={logout}>
                        <FormattedMessage {...messages.logout} />
                    </button>
                </div>
            </div>
        );
    }

    render() {
        const { closeDialog, role, client } = this.props;
        if (role.role === RoleDefinitions.Contractor.type && !client) {
            return null;
        }

        return (
            <Modal managedClose size="col-lg-6 col-lg-offset-3 col-xs-12" onClose={closeDialog} open={true}>
                {this.renderTitle()}
                {this.renderMessage()}
                {this.renderButtons()}
            </Modal>
        );
    }
}

OnboardingDialog.defaultProps = {
    role: undefined,
    closeDialog: undefined
};
OnboardingDialog.propTypes = {
    role: PropTypes.object.isRequired,
    closeDialog: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    job: state.onboarding.job,
    user: state.identity.profile,
    client: state.onboarding.client,
    details: state.identity.details
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getJob: getJob,
            logout: logout
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingDialog);



// WEBPACK FOOTER //
// ./src/pages/onboarding/dialogs/dialog.jsx